import React from 'react';
import {
  ChatRequestModalOverlay,
  ChatRequestsListModalContent,
  ChatRequestModalHeader,
  ChatRequestModalTitle,
  ChatRequestModalCloseButton,
  ChatRequestModalButtons,
  ChatRequestModalButton,
  ModalScrollBody,
} from '../../../styles/UserWorkspacePageStyles';
import {
  ModalForm,
  ModalFormInput,
  ModalFormStatus,
  ModalFormStatusMessage,
} from '../../../styles/ModalFormStyles';
import ContactSelectList from '../ContactSelectList';
import { useT } from '../../../LocaleContext';

const sectionTitleStyle = {
  fontSize: '0.75rem',
  color: '#888',
  textTransform: 'uppercase',
  letterSpacing: '0.05em',
  margin: '12px 0 6px',
};

const CreateGroupModal = ({
  isOpen,
  onClose,
  groupName,
  contacts,
  selectedConnectIds,
  error,
  onGroupNameChange,
  onToggleContact,
  onCreateGroup,
  onKeyDown,
}) => {
  const t = useT();

  if (!isOpen) return null;

  const hasSelection = (selectedConnectIds || []).length > 0;

  const handleSubmit = (e) => {
    e.preventDefault();
    onCreateGroup();
  };

  return (
    <ChatRequestModalOverlay onClick={onClose}>
      <ChatRequestsListModalContent onClick={(e) => e.stopPropagation()}>
        <ChatRequestModalHeader>
          <div />
          <ChatRequestModalTitle>{t('modals.createGroup')}</ChatRequestModalTitle>
          <ChatRequestModalCloseButton onClick={onClose}>
            ×
          </ChatRequestModalCloseButton>
        </ChatRequestModalHeader>
        <ModalForm $fullWidth $flex onSubmit={handleSubmit}>
          <ModalFormInput
            type="text"
            placeholder={t('modals.groupName')}
            value={groupName}
            onChange={onGroupNameChange}
            $hasError={!!error && !groupName.trim()}
            autoFocus
            maxLength={100}
            onKeyDown={onKeyDown}
          />
          <ModalScrollBody>
            <div style={sectionTitleStyle}>{t('modals.selectMembers')}</div>
            <ContactSelectList
              contacts={contacts}
              selectedConnectIds={selectedConnectIds}
              onToggleContact={onToggleContact}
              emptyMessage={t('modals.noContactsYet')}
            />
          </ModalScrollBody>
          <ModalFormStatus>
            <ModalFormStatusMessage success={false}>{error || ''}</ModalFormStatusMessage>
          </ModalFormStatus>
          <ChatRequestModalButtons>
            <ChatRequestModalButton type="button" onClick={onClose}>
              {t('common.cancel')}
            </ChatRequestModalButton>
            <ChatRequestModalButton
              type="submit"
              primary
              disabled={!groupName.trim() || !hasSelection}
            >
              {t('modals.createGroup')}
            </ChatRequestModalButton>
          </ChatRequestModalButtons>
        </ModalForm>
      </ChatRequestsListModalContent>
    </ChatRequestModalOverlay>
  );
};

export default CreateGroupModal;
